<div
  class="d-flex align-items-center justify-content-between"
  [class.project-overview-header]="projectOverview()"
  style="min-height: 40px;"
>
  <div class="left d-flex align-items-center gap-2">
  </div>
  <app-global-search #globalSearch></app-global-search>
  <div class="middle flex-grow-1 d-flex justify-content-center">

    <p-button
      size="small"
      severity="secondary"
      outlined="true"
      (onClick)="this.openSearch()"
      i18n-pTooltip="@@global-search-tooltip"
      pTooltip="Globale Suche (⌘K)"
    >
      <div class="d-flex header-search-btn gap-2">
        <i class="ri-search-line"></i>
        @if (projectOverview()) {
          <span class="d-none d-md-inline text-muted" i18n="@@project-global-search-label">Suche nach Projekten, Bots, Dateien …</span>
        } @else {
          <span class="d-none d-md-inline text-muted" i18n="@@global-search-button">Suche</span>
        }
        <kbd class="d-none d-lg-inline ms-auto">⌘K</kbd>
      </div>
    </p-button>
  </div>

  <div class="right text-end d-flex align-items-center gap-2">

    <div
      class=" d-inline-block  rounded-circle circle text-center mb-0 top-0 cursor-pointer"
      style="border-radius: 50%;width: 30px;height: 30px;  background-color: #EAEAEA;"
      [popover]="popTemplate"
      [outsideClick]="true"
      placement="left"
    >
      <span
        class="align-middle"
        style="font-size: 8pt; color: black;"
      > {{this.loginService.getInitials()}} </span>




    </div>


  </div>

</div>


<ng-template #popTemplate>
  <ul
    class="list-group list-group-flush m-n3 rounded-3"
    style="min-width: 200px;"
  >
    <li class="list-group-item ">
      <b class="mb-0">{{this.loginService.loggedInUser?.name}}</b>
    </li>


    <li class="list-group-item  align-items-center">
      <div class="row">
        <div class="col">Language</div>
        <div
          class="col col-auto cursor-pointer   col-hover"
          [ngClass]="{'active': this.langService.getLanguage() ==='de'}"
        >
          <span
            class="language-flag "
            style="background-image: url('assets/de.svg');"
            (click)="this.langService.setLanguage('de')"
          ></span>
        </div>

        <div
          class="col col-auto cursor-pointer  col-hover "
          [ngClass]="{'active': this.langService.getLanguage() ==='en'}"
        >
          <span
            class="language-flag "
            style="background-image: url('assets/en.svg');"
            (click)="this.langService.setLanguage('en')"
          ></span>
        </div>

      </div>




    </li>
    <li
      class="list-group-item list-group-item-action cursor-pointer text-center"
      (click)="this.loginService.logout(true)"
    >
      <div class=" align-items-center text-center">
        <i class="ri-logout-box-r-line text-primary ri-lg"></i>
        <span>Logout</span>
      </div>
    </li>

  </ul>
</ng-template>